import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-542509ed"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "some-padding" }
const _hoisted_2 = { class: "form-title" }
const _hoisted_3 = { class: "form-dynamic-row form-group-col-2" }
const _hoisted_4 = { class: "form-dynamic-row form-group-col-3" }
const _hoisted_5 = { class: "form-dynamic-row form-group-col-1" }
const _hoisted_6 = { class: "form-dynamic-row form-group-col-1" }
const _hoisted_7 = { class: "operations-wrap" }
const _hoisted_8 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_select_option = _resolveComponent("select-option")!
  const _component_select_search_patient = _resolveComponent("select-search-patient")!
  const _component_date_picker = _resolveComponent("date-picker")!
  const _component_time_picker = _resolveComponent("time-picker")!
  const _component_text_area = _resolveComponent("text-area")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(!_ctx.appointment_id ? "Novo " : "") + "Agendamento", 1),
    _createVNode(_component_Form, { class: "form-wrap" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_select_option, {
            name: 'acting_id',
            label: 'Profissional',
            readonly: true,
            options: _ctx.actuations_options,
            empty_message: 'Cadastre um professional',
            modelValue: _ctx.body.acting_id,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.body.acting_id) = $event)),
            onUpdateValidation: _ctx.updateValidation
          }, null, 8, ["options", "modelValue", "onUpdateValidation"]),
          _createVNode(_component_select_search_patient, {
            name: 'patient_id',
            label: 'Paciente',
            empty_message: 'Nenhum um paciente encontrado',
            modelValue: _ctx.body.patient_id,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.body.patient_id) = $event)),
            required: true,
            readonly: !!_ctx.appointment_id,
            onUpdateValidation: _ctx.updateValidation
          }, null, 8, ["modelValue", "readonly", "onUpdateValidation"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_date_picker, {
            name: 'scheduled_day',
            label: 'Data Marcada',
            required: true,
            modelValue: _ctx.body.scheduled_day,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.body.scheduled_day) = $event)),
            onUpdateValidation: _ctx.updateValidation
          }, null, 8, ["modelValue", "onUpdateValidation"]),
          _createVNode(_component_time_picker, {
            name: 'start_time',
            label: 'Início atendimento',
            modelValue: _ctx.body.start_time,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.body.start_time) = $event)),
            required: true,
            onUpdateValidation: _ctx.updateValidation
          }, null, 8, ["modelValue", "onUpdateValidation"]),
          _createVNode(_component_time_picker, {
            modelValue: _ctx.body.end_time,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.body.end_time) = $event)),
            name: 'end_time',
            label: 'Fim atendimento',
            custom_clock: _ctx.clocks.end,
            disabled: !_ctx.field_valid.start_time,
            onUpdateValidation: _ctx.updateValidation
          }, null, 8, ["modelValue", "custom_clock", "disabled", "onUpdateValidation"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_text_area, {
            modelValue: _ctx.body.complaint,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.body.complaint) = $event)),
            label: 'Queixa/Anamnese'
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_text_area, {
            modelValue: _ctx.body.prescription,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.body.prescription) = $event)),
            label: 'Receita'
          }, null, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("button", {
        class: _normalizeClass({
          btn: true,
          'btn-update': !_ctx.isLoading && _ctx.isFormValid && !!_ctx.appointment_id,
          'btn-new': !_ctx.isLoading && _ctx.isFormValid && !!!_ctx.appointment_id,
        }),
        disabled: !_ctx.isFormValid || _ctx.isLoading,
        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.save()))
      }, " Salvar ", 10, _hoisted_8)
    ])
  ]))
}